import script from "./msgItemShell.vue?vue&type=script&setup=true&lang=js"
export * from "./msgItemShell.vue?vue&type=script&setup=true&lang=js"

import "./msgItemShell.vue?vue&type=style&index=0&id=558a6792&lang=scss&scoped=true"

import exportComponent from "/Users/tangyinbo/workspace/front/syb/syb_webchat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-558a6792"]])

export default __exports__